import { fetch } from '../../utils';
import Backend from '../../backend';
import moment from 'moment';

export const getDataAnalyticsToken = data => {
  return fetch(Backend.methodUrl('getDataAnalyticsToken'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(res => {
      return res.json();
    })
    .then(payload => {
      return payload;
    })
    .catch(error => {
      throw error;
    });
};

export const getDataAnalyticsAccessToken = async () => {
  let accessToken = localStorage.getItem('dataAnalyticsAccessToken');
  let expirationTime = localStorage.getItem('dataAnalyticsAccessTokenExpirationTime');
  // let tokenSource = "localStorage";
  const currentTime = moment().add(1, 'minute');
  if (
    !accessToken ||
    !expirationTime ||
    // check if expiration time is after current time + 1minute
    moment(expirationTime).isBefore(currentTime)
  ) {
    const response = await fetch(Backend.methodUrl('getDataAnalyticsToken'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    const data = await response.json();
    // console.log("getDataAnalyticsAccessToken response", data);
    accessToken = data.accessToken;
    expirationTime = data.accessTokenExpirationTime;
    localStorage.setItem('dataAnalyticsAccessToken', accessToken);
    localStorage.setItem('dataAnalyticsAccessTokenExpirationTime', expirationTime);
    // tokenSource = "api";
  }
  // console.log("getDataAnalyticsAccessToken",  expirationTime, " tokenSource:", tokenSource);
  return accessToken;
};

export const clearStoredTokens = () => {
  localStorage.removeItem('dataAnalyticsAccessToken');
  localStorage.removeItem('dataAnalyticsAccessTokenExpirationTime');
};
